import { z } from 'zod'

export const STRATALYST_QC_SCORING_CONTRACT_VERSION = '1.0.0' as const
export const stratalystQcScoringResponseSchema = z.unknown()
export type StratalystQcScoringResponse = z.infer<typeof stratalystQcScoringResponseSchema>
